import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const IpWarming = lazy(() =>
  import("@scenes/IpWarming").then((module) => ({
    default: module.IpWarming,
  }))
);

/**
 * Legacy IP warming route. With `multiple_ip_warming_plans` off it renders the single-plan
 * experience; with it on it redirects to the Email Preferences "Automated IP Warming" tab
 * (see `ipWarmingNRO`). Slated for removal once the flipper is fully rolled out and this
 * route can become a plain server-side redirect for old bookmarks and mailer links.
 */
export const legacyIpWarmingNRO: NavigationRoutingObject = {
  section: "welcome",
  Component: IpWarming,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("ip-warming-nro-heading", "Automated IP Warming"),
  pageNameForTracking: () => "Automated IP Warming",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("automated_ip_warming");
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    { keywords: [t("ip-warming-nro-alt-keyword-1", "IP Warming")] },
  ],
  additionalSearchableFeatures: () => ({}),
};
